import Notification from '../components/common/Notification';

const ThatsNotify =  {
  install (Vue, options) {
    let innerOptions;
    if (options) {
      innerOptions = options;
    } else {
      innerOptions = {};
    }
    let showedToastrs = [];

    const showToast = function (obj, type) {
      const ToastrComponent = Vue.extend(Notification);
      var propsData = Object.assign(innerOptions, obj, {
        type
      });
      let component = new ToastrComponent({
        el: document.createElement('div'),
        propsData
      });

      showedToastrs.push(component);

      return component;
    };

    Vue.prototype.$ThatsNotify = {
      success(obj = {}) {
        const config = { title: "Success", message: 'Record was successfully created.', position: 'top right', timeOut: 5000 }
        if (Object.keys(obj).length > 0){
          Object.keys(obj).forEach(prop => config[prop] = obj[prop]);
        }
        return showToast(config, 'success');
      },
      info(obj = {}) {
        const config = { title: "Info", message: 'Heads up! Some setup requires to be done', position: 'top right', timeOut: 10000 }
        if (Object.keys(obj).length > 0) {
          Object.keys(obj).forEach(prop => config[prop] = obj[prop]);
        }
        return showToast(config, 'info');
      },
      warning(obj = {}) {
        const config = { title: "Warning", message: 'Unable to create or update record', position: 'top right', timeOut: 5000}
        if (Object.keys(obj).length > 0) {
          Object.keys(obj).forEach(prop => config[prop] = obj[prop]);
        }
        return showToast(obj, 'warning');
      },
      error(obj = {}) {
        const config = { title: "Error", message: 'Internal Server Error', position: 'top right', timeOut: 5000}
        if (Object.keys(obj).length > 0) {
          Object.keys(obj).forEach(prop => config[prop] = obj[prop]);
        }
        return showToast(config, 'error');
      },
      removeAll() {
        showedToastrs.forEach(c => {
          c.hideToastr();
        });
        showedToastrs = [];
      }
    };
  }
};

export default ThatsNotify;
